import { styled } from '@mui/system';
import CheckIcon from '@mui/icons-material/Check';

export const CheckBoxArea = styled('div')(() => ({
  padding: '15px',
  display: 'flex',
  border: 'none',
  flexDirection: 'row',
  justifyContent: 'space-between',
  alignItems: 'center',
  backgroundColor: '#eee',
  borderRadius: '8px',
  margin: '10px 0'
}));

export const SquareRadio = styled('div')(() => ({
  width: '20px',
  height: '20px',
  border: '2px solid #00000099',
  backgroundColor: '#eee',
  borderRadius: '2px',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  position: 'relative',
  transition: 'background-color 0.3s ease'
}));

export const SquareRadioChecked = styled(SquareRadio)(() => ({
  backgroundColor: '#00000099',
  border: 0
}));

export const StyledCheckIcon = styled(CheckIcon)(() => ({
  color: '#eee',
  fontSize: '16px'
}));
